import React from 'react'
import { useTranslation } from 'react-i18next'
import { H3, LayoutBand, Paragraph, Separator } from '@fs/zion-ui'

export default function Unauthorized() {
  const { t } = useTranslation()
  return (
    <LayoutBand>
      <Separator size="xl" />
      <H3>{t('unauthorized.title', 'Unauthorized')}</H3>
      <Separator size="lg" />
      <Paragraph size="sm">{t('unauthorized.message', 'You do not have permission to access this page.')}</Paragraph>
    </LayoutBand>
  )
}
